import { Select,Form } from 'antd'
import React, { useEffect, useState } from 'react'
import { useGwGoodsListQuery } from '../../store/ReactWebSiteApi';
function GetWebGoods(props) {    
    const {data,isSuccess} = useGwGoodsListQuery({
        eowg_e_id:localStorage.getItem('e_id'),
        eowg_sub_type_id:props.eowgts_id||'',
        eowg_type_id:props.eowgt_id||'',
    },{refetchOnMountOrArgChange:1})    
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                const newArr = data.Result.map(item => {
                    const {eowg_id:key,eowg_name,} = item;
                    return item = {value:key,label:eowg_name,}
                })                
               
                setList(newArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    return (
        <Form.Item 
            label={props.label} 
            wrapperCol={props.wrapperCol} 
            required={props.required}
            name={props.name}
            style={props.formStyle}
        >
            <Select 
                options={list} 
                onChange={(_,f) => {
                    props.onChange(f.value,f.label,f.ed_id,f.ed_name)
                }}
                placeholder={props.placeholder}
                style={props.style}
            />
        </Form.Item>
    )
}

export default GetWebGoods